import React from "react"
import DeviceCard from "../DeviceCard"
import DeviceListEmpty from "../DeviceListEmpty"

const gridClass = {
	1: "grid-cols-1",
	2: "grid-cols-1 sm:grid-cols-2",
	3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3",
	4: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4",
} as const

interface ConnectionStatus {
	status: "connected" | "disconnected" | "unknown"
	timestamp?: string
	displayText: string
}

interface ShadowDevice {
	deviceId: string
}

interface DeviceGridProps {
	devices: ShadowDevice[]
	cardsPerRow: 1 | 2 | 3 | 4
	isLiveMode: boolean
	showFavoritesOnly: boolean
	hasUserDevices: boolean
	getConnectionStatus: (deviceId: string) => ConnectionStatus
	onRefresh: (deviceId: string) => void
}

const DeviceGrid: React.FC<DeviceGridProps> = ({
	devices,
	cardsPerRow,
	isLiveMode,
	showFavoritesOnly,
	hasUserDevices,
	getConnectionStatus,
	onRefresh,
}) => {
	if (devices.length === 0) {
		return (
			<DeviceListEmpty
				showFavoritesOnly={showFavoritesOnly}
				hasUserDevices={hasUserDevices}
				isLiveMode={isLiveMode}
			/>
		)
	}

	return (
		<div className={`grid ${gridClass[cardsPerRow] ?? gridClass[3]} gap-6`}>
			{devices.map((device) => (
				<DeviceCard
					key={device.deviceId}
					deviceId={device.deviceId}
					onRefresh={() => onRefresh(device.deviceId)}
					isLiveMode={isLiveMode}
					connectionStatus={getConnectionStatus(device.deviceId)}
				/>
			))}
		</div>
	)
}

export default DeviceGrid
